import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  from: Yup.mixed().required("Start Date is required"),
  to: Yup.mixed().required("End Date is required"),
});
